import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, OnInit, output, Output, signal, TemplateRef } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ENVIRONMENT, User } from '@company-box/models';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { TermsComponent } from '../../common/terms/terms.component';
import { PrivacyPolicyComponent } from '../../common/privacy-policy/privacy-policy.component';


@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  imports: [CommonModule, RouterModule, LoginModalComponent, TermsComponent, PrivacyPolicyComponent]
})
export class NavRightComponent implements OnInit {

  @Output() close: EventEmitter<any> = new EventEmitter();

  protected environment = inject(ENVIRONMENT);

  constructor(
    private bsModalService: BsModalService) {
  }

  private modal: BsModalRef | undefined;
  private activeLoginModalTab = 'login';
  public openCategory = signal<string>('');
  public rewardsEnabled = !!this.environment.features?.rewards;

  user = input<User | undefined>();
  toggleLogout = output();

  ngOnInit() {

  }

  getActiveTab(tab: string) {
    if (this.activeLoginModalTab === tab) {
      return 'active';
    } else {
      return 'inactive';
    }
  }

  logout() {
    this.toggleLogout.emit()
  }

  showModal(template: TemplateRef<any>) {
    this.modal = this.bsModalService.show(template);
  }

  hide() {
    this.modal?.hide();
  }

  categoryTapped(category: string) {
    if (this.openCategory() === category) {
      this.openCategory.set('');
    } else {
      this.openCategory.set(category);
    }
  }
}
